document.addEventListener('DOMContentLoaded', function() {
  /**
   * Fix for app block Shopify Subscriptions.
   * Hydrates the app inserted selling plan id inputs..
   */
  const subscriptionAppBlockWrapper = document.querySelector('.shopify_subscriptions_app_block');
  const sellingPlanStateInputs = [...document.querySelectorAll('.selected-selling-plan-id')];
    
  if (subscriptionAppBlockWrapper && sellingPlanStateInputs.length) {
    subscriptionAppBlockWrapper.addEventListener('change', (e) => {
      sellingPlanStateInputs.forEach(item => {
        item.value = e.target.dataset.sellingPlanId || '';
      });
    });
  }
});